import { Component, OnInit, ViewEncapsulation, Input, ElementRef, AfterViewInit } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ROUTES } from './sidebar-routes.config';
import { RouteInfo } from "./sidebar.metadata";
import { Router, ActivatedRoute } from "@angular/router";
import { IntervalObservable } from "rxjs/observable/IntervalObservable";
import { ApiService, URLS } from "app/services/api.service";
import { UserStorageService } from "app/services/user-storage.service";
import { DataService } from 'app/services/data-service';
import { isNullOrUndefined } from 'util';


//declare var $: any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class SidebarComponent implements OnInit, AfterViewInit {
  public menuItems: any[];
  public acesso: any[];
  public matriculaUsuario: string;
  public nomeUsuario: string;
  private keyMenu: string = 'menu-sidebar';
  private user;
  public url: string;
  public menuRelatorio: string;

  closeResult: string;
  messages = new Array();
  actionBtn = [];

  constructor(private router: Router,
    private route: ActivatedRoute,
    private apiservice: ApiService,
    private userService: UserStorageService,
    private modalService: NgbModal,
    private dataService: DataService,
    private elRef: ElementRef) {
    //console.log('sidebar component constructor');
  }

  ngOnInit() {
    //this.url = this.apiservice.getHostRio();
    var vm = this;
    //console.log('sidebar component on init');
    // $.getScript('assets/js/app-sidebar.js');
    this.menuItems = ROUTES.filter(menuItem => menuItem);
    vm.user = this.userService.getUser();
    //console.log("user sidebar: ", vm.user);
    //vm.loadMenu(vm.user);

    let menuAutorizado = [];
    if (!isNullOrUndefined(vm.user.original)) {
      if (vm.user.original[0].roles[0].name == 'Operador') {
        vm.menuItems.forEach(element => {
          if (element.title != 'Perfis' && element.title != 'Permissões') {
            menuAutorizado.push(element);
          }
        });
        this.menuItems = menuAutorizado;

      }
    }







    // IntervalObservable.create(30000)
    //     .subscribe(() => {
    //         //console.log("GET USUARIO ACESSO");
    //         if (vm.user != null){
    //             vm.apiservice.get(URLS.GET_USUARIO_ACESSO, vm.user["idUsuario"], this.apiservice.getHostRio())
    //             .subscribe(
    //                 function(data){
    //                     if (data && vm.user["acesso"] != data){
    //                         vm.user["acesso"] = data;
    //                         var userOld = vm.userService.getUser();
    //                         if (userOld != null){
    //                             vm.userService.setUser(vm.user);
    //                         }
    //                         vm.loadMenu(vm.user);
    //                     }
    //                     if (vm.userService.isBlock()){
    //                         vm.router.navigate(['/lockscreen']);
    //                         //console.log('block');
    //                     } else {
    //                         //console.log('no block');
    //                     }
    //                 },
    //                 function(error){
    //                     console.log(error);
    //                 });
    //         }
    //     });
  }

  ngAfterViewInit() {
    $.getScript('assets/js/app-sidebar.js');
  }

  //loadMenu(user){
  //if (user != null){
  //this.menuItems = [];
  //console.log('user teste rota', user);
  //let nome : string = user['Nome'];
  //let pos: number = nome.indexOf(" ");
  //this.nomeUsuario = nome.substring(0, pos);
  //this.matriculaUsuario = user['nmUsuario'];
  /*this.acesso = user['acesso'];
  let index: number = 0;
  for (let i: number = 0; i < this.acesso.length; i++){
      let nmSistema : string =  this.acesso[i]['nmSistema'];
      //if (nmSistema !== "Portal"){
          let rota : string = this.acesso[i]['rotaSistema'];
          let pos1 = rota.lastIndexOf("/");
          if (pos1 != -1){
              let origem : number = this.acesso[i]['idOrigemSistema'];
              if (origem == 1){
                  rota = "/frame" + rota;
              } else {
                  rota = rota.substring(pos1);
              }
          } else {
              rota = "/" + rota.toLowerCase();
          }
          let menu = {
              path: rota,
              title: this.acesso[i]['nmSistema'],
              icon: this.acesso[i]['classCss'],
              class: '',
              badge: '',
              badgeClass: '',
              isExternalLink: false,
              submenu: []
          }
          //console.log(menu);
          //this.dataService.put(this.keyMenu, menu);
          this.menuItems[index] = menu;
          index++;
      //}
  }*/
  //console.log(this.menuItems);
  // } else {
  //this.router.navigate(['/login']);
  //}
  //}

  // Open default modal
  open(message) {
    this.dataService.sendMessage(message);
  }

  // This function is used in open
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  // Open modal with dark section
  openModal(customContent) {
    this.modalService.open(customContent, { windowClass: 'dark-modal' });
  }

  // Open content with dark section
  // openContent() {
  //     const modalRef = this.modalService.open(NgbdModalContent);
  //     modalRef.componentInstance.name = 'World';
  // }

  SetActive(event) {
    const hElement: HTMLElement = this.elRef.nativeElement;
    const allAnchors = hElement.getElementsByClassName('list-group-item');

    [].forEach.call(allAnchors, (item: HTMLElement) => {
      item.classList.remove('gradient-purple-bliss');
      item.classList.add('no-border');
    });

    event.currentTarget.classList.remove('no-border');
    event.currentTarget.classList.add('gradient-purple-bliss');
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/sidebar/sidebar.component.ts